var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapVertBlack24Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "swap_vert_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.512,
    height: 29.512,
    viewBox: "0 0 29.512 29.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_278804",
    "data-name": "Path 278804",
    d: "M0,0H29.512V29.512H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_278805",
    "data-name": "Path 278805",
    d: "M12.364,21.18V13.79a1.23,1.23,0,1,0-2.459,0v7.39H7.7a.609.609,0,0,0-.43,1.045L10.7,25.643a.631.631,0,0,0,.873,0l3.431-3.418a.611.611,0,0,0-.43-1.045Zm-11.038-8.8-3.431,3.431a.609.609,0,0,0,.43,1.045h2.2v7.39a1.23,1.23,0,0,0,2.459,0v-7.39h2.2a.609.609,0,0,0,.43-1.045L2.186,12.383a.616.616,0,0,0-.861,0Z",
    transform: "translate(8.29 -4.208)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVertBlack24Dp);
export default __webpack_public_path__ + "static/media/swap_vert_black_24dp.c0407f4e10d0d4e8887898a4a1c69efa.svg";
export { ForwardRef as ReactComponent };